import {
  AccountHeaderButton,
  type AccountHeaderButtonProps,
} from "@repo/profiles/components/account-header-button"

import { useAccountSettings } from "./account-settings-context"

export type AccountMenuProps = Omit<
  AccountHeaderButtonProps,
  "onOpenAccountSettings"
>

/**
 * The account avatar menu wired to the shared account settings modal. Use this
 * everywhere the account menu appears instead of {@link AccountHeaderButton}
 * directly so a single modal instance is reused.
 */
export function AccountMenu(props: AccountMenuProps) {
  const { open } = useAccountSettings()
  return <AccountHeaderButton {...props} onOpenAccountSettings={open} />
}
